import slugify from 'slugify';

import type { EventDetails } from './types';
import { createGoogleCalendarUrl, createICSCalendarUrl } from './url-factories';

interface CalendarLink {
  download?: string;
  href: string;
  key: string;
  title: string;
  icon: 'apple' | 'google' | 'outlook';
}

const createCalendarLinks = (event: EventDetails): CalendarLink[] => [
  {
    download: `${slugify(event.title, { lower: true })}.ics`,
    href: createICSCalendarUrl(event),
    key: 'apple',
    title: 'iCal',
    icon: 'apple',
  },
  {
    href: createGoogleCalendarUrl(event),
    key: 'google',
    title: 'Google Calendar',
    icon: 'google',
  },
  {
    download: `${slugify(event.title, { lower: true })}.ics`,
    href: createICSCalendarUrl(event),
    key: 'outlook',
    title: 'Outlook',
    icon: 'outlook',
  },
];

// eslint-disable-next-line import/no-default-export
export default createCalendarLinks;
